export class SongLibrary {
    constructor() {
        this.songs = [
            // English Folk Songs
            {
                id: 'twinkle-star',
                title: 'Twinkle, Twinkle, Little Star',
                language: 'en',
                author: 'Traditional',
                epoch: 'Traditional Folk',
                theme: 'Lullaby',
                difficulty: 'easy',
                lyrics: [
                    'Twinkle, twinkle, little star,',
                    'How I wonder what you are!',
                    'Up above the world so high,',
                    'Like a diamond in the sky.',
                    'Twinkle, twinkle, little star,',
                    'How I wonder what you are!'
                ],
                melody: [
                    { note: 'C4', duration: 0.5, lyric: 'Twin' },
                    { note: 'C4', duration: 0.5, lyric: 'kle' },
                    { note: 'G4', duration: 0.5, lyric: 'twin' },
                    { note: 'G4', duration: 0.5, lyric: 'kle' },
                    { note: 'A4', duration: 0.5, lyric: 'lit' },
                    { note: 'A4', duration: 0.5, lyric: 'tle' },
                    { note: 'G4', duration: 1.0, lyric: 'star' }
                ]
            },
            {
                id: 'mary-lamb',
                title: 'Mary Had a Little Lamb',
                language: 'en',
                author: 'Traditional',
                epoch: 'Traditional Folk',
                theme: 'Children\'s Song',
                difficulty: 'easy',
                lyrics: [
                    'Mary had a little lamb,',
                    'Little lamb, little lamb,',
                    'Mary had a little lamb,',
                    'Its fleece was white as snow.'
                ],
                melody: [
                    { note: 'E4', duration: 0.5, lyric: 'Ma' },
                    { note: 'D4', duration: 0.5, lyric: 'ry' },
                    { note: 'C4', duration: 0.5, lyric: 'had' },
                    { note: 'D4', duration: 0.5, lyric: 'a' },
                    { note: 'E4', duration: 0.5, lyric: 'lit' },
                    { note: 'E4', duration: 0.5, lyric: 'tle' },
                    { note: 'E4', duration: 1.0, lyric: 'lamb' }
                ]
            },
            {
                id: 'happy-birthday',
                title: 'Happy Birthday',
                language: 'en',
                author: 'Traditional',
                epoch: 'Traditional',
                theme: 'Celebration',
                difficulty: 'easy',
                lyrics: [
                    'Happy birthday to you,',
                    'Happy birthday to you,',
                    'Happy birthday dear friend,',
                    'Happy birthday to you!'
                ],
                melody: [
                    { note: 'C4', duration: 0.25, lyric: 'Hap' },
                    { note: 'C4', duration: 0.25, lyric: 'py' },
                    { note: 'D4', duration: 0.5, lyric: 'birth' },
                    { note: 'C4', duration: 0.5, lyric: 'day' },
                    { note: 'F4', duration: 0.5, lyric: 'to' },
                    { note: 'E4', duration: 1.0, lyric: 'you' }
                ]
            },
            {
                id: 'old-macdonald',
                title: 'Old MacDonald Had a Farm',
                language: 'en',
                author: 'Traditional',
                epoch: 'Traditional Folk',
                theme: 'Children\'s Song',
                difficulty: 'medium',
                lyrics: [
                    'Old MacDonald had a farm, E-I-E-I-O!',
                    'And on his farm he had a cow, E-I-E-I-O!',
                    'With a moo-moo here and a moo-moo there,',
                    'Here a moo, there a moo, everywhere a moo-moo!',
                    'Old MacDonald had a farm, E-I-E-I-O!'
                ],
                melody: [
                    { note: 'G4', duration: 0.5, lyric: 'Old' },
                    { note: 'G4', duration: 0.5, lyric: 'Mac' },
                    { note: 'G4', duration: 0.5, lyric: 'Don' },
                    { note: 'D4', duration: 0.5, lyric: 'ald' },
                    { note: 'E4', duration: 0.5, lyric: 'had' },
                    { note: 'E4', duration: 0.5, lyric: 'a' },
                    { note: 'D4', duration: 1.0, lyric: 'farm' }
                ]
            },
            {
                id: 'ode-to-joy',
                title: 'Ode to Joy',
                language: 'en',
                author: 'Ludwig van Beethoven',
                epoch: 'Classical (1824)',
                theme: 'Classical',
                difficulty: 'medium',
                lyrics: [
                    'Joy, bright spark of divinity,',
                    'Daughter of Elysium,',
                    'Fire-inspired we tread,',
                    'Thy sanctuary.'
                ],
                melody: [
                    { note: 'E4', duration: 0.5, lyric: 'Joy' },
                    { note: 'E4', duration: 0.5, lyric: 'bright' },
                    { note: 'F4', duration: 0.5, lyric: 'spark' },
                    { note: 'G4', duration: 0.5, lyric: 'of' },
                    { note: 'G4', duration: 0.5, lyric: 'di' },
                    { note: 'F4', duration: 0.5, lyric: 'vi' },
                    { note: 'E4', duration: 0.5, lyric: 'ni' },
                    { note: 'D4', duration: 0.5, lyric: 'ty' }
                ]
            },

            // Russian Folk Songs
            {
                id: 'kalinka',
                title: 'Калинка (Kalinka)',
                language: 'ru',
                author: 'Иван Ларионов (Ivan Larionov)',
                epoch: 'Russian Folk (1860)',
                theme: 'Folk Dance',
                difficulty: 'medium',
                lyrics: [
                    'Калинка, калинка, калинка моя!',
                    'В саду ягода малинка, малинка моя!',
                    'Ах, под сосною, под зелёною,',
                    'Спать положите вы меня!'
                ],
                melody: [
                    { note: 'A4', duration: 0.25, lyric: 'Ка' },
                    { note: 'A4', duration: 0.25, lyric: 'лин' },
                    { note: 'A4', duration: 0.5, lyric: 'ка' },
                    { note: 'A4', duration: 0.25, lyric: 'ка' },
                    { note: 'A4', duration: 0.25, lyric: 'лин' },
                    { note: 'A4', duration: 0.5, lyric: 'ка' }
                ]
            },
            {
                id: 'katyusha',
                title: 'Катюша (Katyusha)',
                language: 'ru',
                author: 'Матвей Блантер (Matvey Blanter)',
                epoch: 'Soviet (1938)',
                theme: 'Patriotic',
                difficulty: 'medium',
                lyrics: [
                    'Расцветали яблони и груши,',
                    'Поплыли туманы над рекой.',
                    'Выходила на берег Катюша,',
                    'На высокий берег на крутой.'
                ],
                melody: [
                    { note: 'G4', duration: 0.5, lyric: 'Рас' },
                    { note: 'E4', duration: 0.5, lyric: 'цве' },
                    { note: 'C4', duration: 0.5, lyric: 'та' },
                    { note: 'E4', duration: 0.5, lyric: 'ли' },
                    { note: 'G4', duration: 0.5, lyric: 'яб' },
                    { note: 'G4', duration: 0.5, lyric: 'ло' },
                    { note: 'A4', duration: 0.5, lyric: 'ни' }
                ]
            },
            {
                id: 'v-lesu-rodilas',
                title: 'В лесу родилась ёлочка (In the Forest a Christmas Tree)',
                language: 'ru',
                author: 'Леонид Бекман (Leonid Bekman)',
                epoch: 'Russian (1905)',
                theme: 'Holiday/Christmas',
                difficulty: 'easy',
                lyrics: [
                    'В лесу родилась ёлочка,',
                    'В лесу она росла,',
                    'Зимой и летом стройная,',
                    'Зелёная была.'
                ],
                melody: [
                    { note: 'C4', duration: 0.5, lyric: 'В' },
                    { note: 'E4', duration: 0.5, lyric: 'ле' },
                    { note: 'E4', duration: 0.5, lyric: 'су' },
                    { note: 'E4', duration: 0.5, lyric: 'ро' },
                    { note: 'F4', duration: 0.5, lyric: 'ди' },
                    { note: 'E4', duration: 0.5, lyric: 'лась' },
                    { note: 'D4', duration: 1.0, lyric: 'ё' }
                ]
            },
            {
                id: 'korobeiniki',
                title: 'Коробейники (Korobeiniki/Tetris Theme)',
                language: 'ru',
                author: 'Traditional',
                epoch: 'Russian Folk',
                theme: 'Folk',
                difficulty: 'hard',
                lyrics: [
                    'Ой, полным-полна коробушка,',
                    'Есть и ситец и парча.',
                    'Пожалей, душа-зазнобушка,',
                    'Молодецкого плеча!'
                ],
                melody: [
                    { note: 'E5', duration: 0.5, lyric: 'Ой' },
                    { note: 'B4', duration: 0.25, lyric: 'пол' },
                    { note: 'C5', duration: 0.25, lyric: 'ным' },
                    { note: 'D5', duration: 0.5, lyric: 'пол' },
                    { note: 'C5', duration: 0.25, lyric: 'на' },
                    { note: 'B4', duration: 0.25, lyric: 'ко' },
                    { note: 'A4', duration: 0.5, lyric: 'ро' }
                ]
            },
            {
                id: 'dorogoi-dlinnoju',
                title: 'Дорогой длинною (Those Were the Days)',
                language: 'ru',
                author: 'Boris Fomin',
                epoch: 'Russian (1920s)',
                theme: 'Romance',
                difficulty: 'medium',
                lyrics: [
                    'Дорогой длинною,',
                    'Погожим летним днём,',
                    'Мы ехали на тройке с бубенцами,',
                    'И вдалеке мелькали огоньки.'
                ],
                melody: [
                    { note: 'D4', duration: 0.5, lyric: 'До' },
                    { note: 'E4', duration: 0.5, lyric: 'ро' },
                    { note: 'F4', duration: 0.5, lyric: 'гой' },
                    { note: 'G4', duration: 0.75, lyric: 'длин' },
                    { note: 'F4', duration: 0.25, lyric: 'но' },
                    { note: 'E4', duration: 1.0, lyric: 'ю' }
                ]
            }
        ];
    }

    getSongs(filter = 'all') {
        if (filter === 'all') {
            return this.songs;
        }
        
        return this.songs.filter(song => song.language === filter);
    }

    getSongById(id) {
        return this.songs.find(song => song.id === id);
    }

    getSongsByDifficulty(difficulty) {
        return this.songs.filter(song => song.difficulty === difficulty);
    }

    getSongsByEpoch(epoch) {
        return this.songs.filter(song => song.epoch.includes(epoch));
    }

    getSongsByTheme(theme) {
        return this.songs.filter(song => song.theme === theme);
    }

    getRandomSong(language = null) {
        const filtered = language ? this.getSongs(language) : this.songs;
        return filtered[Math.floor(Math.random() * filtered.length)];
    }
}

/**
 * Resources for additional songs:
 * 
 * Public Domain MIDI Databases:
 * - IMSLP (International Music Score Library Project): https://imslp.org/
 *   - Large collection of public domain classical music scores and MIDI files
 * 
 * - MuseScore: https://musescore.com/sheetmusic
 *   - Community-contributed scores, many public domain
 * 
 * - Classical MIDI Connection: http://www.classicalmidiconnection.com/
 *   - Public domain classical MIDI files
 * 
 * - Free MIDI: https://freemidi.org/
 *   - Collection of free and public domain MIDI files
 * 
 * Russian Folk Songs:
 * - Traditional Russian folk songs are generally public domain
 * - Many Soviet-era songs entered public domain
 * - Check copyright status for post-1926 compositions
 * 
 * For implementation:
 * - Convert MIDI to JSON format with note/duration data
 * - Use Tone.js or similar library to play back melodies
 * - Sync lyrics with melody timing
 * - Allow users to follow along and practice pitch matching
 */
